export const Message = props => {
    return <>
        <p>{props.text}</p>
    </>
}